import { render, staticRenderFns } from "./NicheAreaAdd.vue?vue&type=template&id=5c8da6d0&scoped=true"
import script from "./NicheAreaAdd.vue?vue&type=script&lang=js"
export * from "./NicheAreaAdd.vue?vue&type=script&lang=js"
import style0 from "./NicheAreaAdd.vue?vue&type=style&index=0&id=5c8da6d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8da6d0",
  null
  
)

export default component.exports